export function navigateToAdmin() {
  window.location.href = "admin";
}
